import StyleToggle from './StyleToggle'
import Globals from './Globals'

const ColorToggle = (props) => {
    return (
        <StyleToggle
            value={props.value}
            update={props.update}
            styles={Globals.colors}
            buttonStyleProp={'backgroundColor'}
            content={''}
        />
    )
}

export default ColorToggle
